require('datejs/src/i18n/cs-CZ.js');
require('datejs');